var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"branch"},[_c('div',{staticClass:"header"},[_c('h6',[_vm._v(_vm._s(_vm.branch.name))])]),_c('h6',[_c('span',[_vm._v("الهاتف")]),_vm._v(" "+_vm._s(_vm.branch.phone))]),_c('h6',[_c('span',[_vm._v("العنوان")]),_vm._v(" "+_vm._s(_vm.branch.address))]),_c('div',{staticClass:"edit-delete"},[_vm._t("edit-delete")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }